import { render } from "./InvoiceApprovalListCell.vue?vue&type=template&id=59904bfc&scoped=true&ts=true"
import script from "./InvoiceApprovalListCell.vue?vue&type=script&lang=ts"
export * from "./InvoiceApprovalListCell.vue?vue&type=script&lang=ts"

import "./InvoiceApprovalListCell.vue?vue&type=style&index=0&id=59904bfc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59904bfc"]])

export default __exports__